import { TransformationRuleDTO } from "../DTO/transformationRuleDTO";
import { TransformationRuleAI } from "../responses/generateTransformationResponse";
import { TransformationRuleDefinition } from "./transformationRuleDefinition";

export class TransformationRule{

    public id!:number;
    public sequenceNo!:number; //zero based index to orchestrate sequential execution of rules
    public transformationRuleDefinitionId!:number;
    public transformationRuleDefinition!:TransformationRuleDefinition;
    public transformationParameter1?:string; // additional information to be used like 'character to be used for padding' or format of output date
    public transformationParameter2?:string; // used in combination with TransformationParameter1 in rules like 'replace character A with character B' where TransformationParameter1 is character A and TransformationParameter2 is character B
    public inputPassthrough:boolean = false; //true if input data shall be passed on to output data. Only first input reference will be passed on. Used only in conditional rules where a condition is not met and the next rule shall apply on input value.
    public breakOnConditionMet:boolean = false; //true if transformation protocol shall stop executing rules upon Condition met. Used only in conditional rules where a condition met and the following rules shall not be executed. 

    public static mapFromDTO(param:TransformationRuleDTO):TransformationRule{ 
        if (!param) throw new Error("parameter is null")
        let obj = new TransformationRule();
        try
        {
            obj.id = param.id;
            obj.sequenceNo = param.sequenceNo;
            obj.transformationRuleDefinitionId = param.transformationRuleDefinitionId;
            obj.transformationParameter1 = param.transformationParameter1;
            obj.transformationParameter2 = param.transformationParameter2;
            obj.inputPassthrough = param.inputPassthrough;
            obj.breakOnConditionMet = param.breakOnConditionMet;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:TransformationRule):TransformationRuleDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new TransformationRuleDTO();
        try
        {
            dto.id = param.id;
            dto.sequenceNo = param.sequenceNo;
            dto.transformationRuleDefinitionId = param.transformationRuleDefinition?param.transformationRuleDefinition.id:param.transformationRuleDefinitionId;
            dto.transformationParameter1 = param.transformationParameter1;
            dto.transformationParameter2 = param.transformationParameter2;
            dto.inputPassthrough = param.inputPassthrough;
            dto.breakOnConditionMet = param.breakOnConditionMet;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public static mapFromAI(param:TransformationRuleAI):TransformationRule{ 
        if (!param) throw new Error("parameter is null")
        let obj = new TransformationRule();
        try
        {
            obj.id = param.id;
            obj.sequenceNo = param.sequenceNo;
            obj.transformationRuleDefinitionId = param.transformationRuleDefinitionId;
            obj.transformationParameter1 = param.transformationParameter1;
            obj.transformationParameter2 = param.transformationParameter2;
            obj.inputPassthrough = param.inputPassthrough;
            obj.breakOnConditionMet = param.breakOnConditionMet;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    get clone(){
        let clone_tr=new TransformationRule();
        clone_tr.id=this.id;
        clone_tr.sequenceNo=this.sequenceNo;
        clone_tr.transformationRuleDefinitionId=this.transformationRuleDefinitionId;
        clone_tr.transformationRuleDefinition=this.transformationRuleDefinition;
        clone_tr.transformationParameter1=this.transformationParameter1;
        clone_tr.transformationParameter2=this.transformationParameter2;
        clone_tr.inputPassthrough=this.inputPassthrough;
        clone_tr.breakOnConditionMet=this.breakOnConditionMet;
        return clone_tr
    }

    public transformationParameter(index:number){
        return index==0?this.transformationParameter1:(index==1?this.transformationParameter2:undefined);
    }
}